<template>
    <pwa_article :pwa="pwa" article_type="conditions"></pwa_article>
</template>

<script>
import pwa_article from "./pwa_article";
export default {
    name: "pwa_article_conditions",
    components : {
        pwa_article
    },
    props : {
        pwa : {
            type:Object
        }
    },
}
</script>

<style scoped>

</style>
